import React from 'react'
import $ from 'jquery'
import TutorialApi from '../api'
import WebviewInvokeApp from '@ssr/lib/webview_invoke_app'
import ThinkingDataSDK from '@ssr/components/Analytics/ThinkingDataSdk'
import VolcEngine from '@ssr/components/Analytics/VolcEngine'

import './index.less'
import { CommonContext } from '@ssr/context'

function createSwiperHelper($root, banners, { speed, swiped, duration, touchstartHandler }) {
  const element = $root.get(0)
  const spacing = $('.block-top').width() - 36
  let currentIndex = 0

  const $templates = banners.map((banner) => {
    return $(/* html */ `
        <a class="banner" href="${banner.detail.url}" style="background-image: url(${banner.cover_type === 'video' ? banner.default_url : banner.cover});" data-id="${banner.id}" data-name="${
      banner.tag
    }">
          <div class="text-group">
            <div class="text">${banner.title}</div>
            ${banner.sub_title ? /* html */ `<div class="text-sm">${banner.sub_title}</div>` : ''}
          </div>
        </a>
      `)
  })

  const $nodes = {
    center: undefined,
    left: undefined,
    right: undefined,
  }

  function translate(offset, speed) {
    const { center, left, right } = $nodes
    const absOffset = Math.abs(offset)

    $root.css({
      transitionDuration: `${speed || 0}ms`,
      transform: `translateX(${offset}px)`,
    })
    center.css({
      transitionDuration: `${speed || 0}ms`,
      transform: `scaleY(${1 - (0.13 * absOffset) / spacing})`,
    })
    left.css({
      transitionDuration: `${speed || 0}ms`,
      transform: `scaleY(${0.87 + (0.13 * absOffset) / spacing})`,
    })
    right.css({
      transitionDuration: `${speed || 0}ms`,
      transform: `scaleY(${0.87 + (0.13 * absOffset) / spacing})`,
    })
  }

  function change(index) {
    let temp
    const direction = index < currentIndex ? 'to_left' : 'to_right'

    if (direction === 'to_left') {
      currentIndex = index < 0 ? banners.length - 1 : index
      temp = $templates[currentIndex - 1 < 0 ? banners.length - 1 : currentIndex - 1].clone()
      temp.css({
        transform: 'scaleY(.87)',
        right: 'calc(24px + 200%)',
      })

      translate(spacing, speed)
    } else {
      currentIndex = index % banners.length
      temp = $templates[(currentIndex + 1) % banners.length].clone()
      temp.css({
        transform: 'scaleY(.87)',
        left: 'calc(24px + 200%)',
      })

      translate(-spacing, speed)
    }
    $root.append(temp)

    swiped && swiped(currentIndex)

    setTimeout(function () {
      const { left, right, center } = $nodes

      if (direction === 'to_left') {
        right.remove()
        $nodes.center = left
        $nodes.right = center
        $nodes.left = temp
      } else {
        left.remove()
        $nodes.center = right
        $nodes.left = center
        $nodes.right = temp
      }

      $nodes.center.css({
        left: 0,
        right: 'auto',
      })
      $nodes.left.css({
        left: 'auto',
        right: 'calc(12px + 100%)',
      })
      $nodes.right.css({
        left: 'calc(12px + 100%)',
        right: 'auto',
      })

      translate(0)

      setTimeout(function () {
        startLoop()

        element.addEventListener('touchstart', events, false)
      })
    }, speed)
  }

  const events = {
    startX: undefined,
    deltaX: undefined,
    handleEvent: function (event) {
      switch (event.type) {
        case 'touchstart':
          this.start(event)
          break
        case 'touchmove':
          this.move(event)
          break
        case 'touchend':
          this.end(event)
          break
      }
    },
    start: function (event) {
      touchstartHandler && touchstartHandler()

      endLoop()

      const touches = event.touches[0]
      this.startX = touches.pageX

      element.addEventListener('touchmove', this, false)
      element.addEventListener('touchend', this, false)
    },
    move: function (event) {
      const touches = event.touches[0]
      this.deltaX = touches.pageX - this.startX

      translate(this.deltaX)
    },
    end: function () {
      if (banners.length >= 2 && this.deltaX && Math.abs(this.deltaX) > 120) {
        if (this.deltaX < 0) {
          change(currentIndex + 1)
        } else {
          change(currentIndex - 1)
        }
      } else {
        translate(0, speed)

        startLoop()
      }

      this.deltaX = undefined
      element.removeEventListener('touchmove', this, false)
      element.removeEventListener('touchend', this, false)
    },
  }

  // 初始化
  if (banners.length <= 1) {
    $templates.forEach(($tpl) => {
      $root.append($tpl.clone())
    })
    return
  }

  $nodes.center = $templates[0].clone()
  $nodes.left = $templates[banners.length - 1].clone()
  $nodes.right = $templates[1].clone()

  $nodes.left.css({
    transform: 'scaleY(.87)',
    right: 'calc(12px + 100%)',
  })
  $nodes.right.css({
    transform: 'scaleY(.87)',
    left: 'calc(12px + 100%)',
  })

  $root.append($nodes.center)
  $root.append($nodes.left)
  $root.append($nodes.right)

  element.addEventListener('touchstart', events, false)

  // 自动切换
  let intervaler
  function startLoop() {
    if (!intervaler) {
      intervaler = setInterval(function () {
        change(currentIndex + 1)
      }, duration)
    }
  }
  function endLoop() {
    clearInterval(intervaler)
    intervaler = undefined
  }
  startLoop()
}

function createSwiper($root, banners) {
  const $swipe = $('<div class="swipe"><div class="placeholder"></div></div>')
  const $indicator = $(
    `<div class="indicator">${banners
      .map(() => {
        return '<div class="point"></div>'
      })
      .join('')}</div>`
  )
  $root.append($swipe)
  $root.append($indicator)

  // 防止滑动 banner 时候的垂直滚动
  let scrollLock = false
  document.body.addEventListener(
    'touchmove',
    function (e) {
      if (scrollLock) {
        e.preventDefault()
      }
    },
    { passive: false }
  )

  document.body.addEventListener('touchend', function (e) {
    scrollLock = false
  })

  // 底部指示器
  const $points = $indicator.find('.point')
  $points.eq(0).addClass('active')

  createSwiperHelper($swipe, banners, {
    speed: 300,
    duration: 3000,
    swiped: (index) => {
      $points.removeClass('active').eq(index).addClass('active')
    },
    touchstartHandler: () => {
      scrollLock = true
    },
  })
}

function init({ _app }) {
  const manualCovers = {
    go: 'https://static.insta360.com/assets/storage/20190805/b2d3f5fcab1182593720acd452a00a94/banner.png',
    oner: 'https://static.insta360.com/assets/storage/20200226/773e3bfabda852b8c74501e5c1b1b624/tutorial_face.png',
  }

  if (manualCovers[_app]) {
    $('.block-bottom .type')
      .first()
      .css({
        backgroundImage: `url(${manualCovers[_app]})`,
      })
  }

  TutorialApi.getTutorialCategory({ app: _app }).then((res) => {
    if (res.code === 0) {
      $('.block-bottom').append(
        res.data.categories
          .map((category) => {
            return /* html */ `
                <a href="/tutorial/items?category_id=${category.id}&category_name=${category.trick}&app=${_app}" class="type" style="background-image: url(${
              category.cover_type === 'video' ? category.default_cover : category.cover
            });" data-type="play">
                  <div class="text-group">
                    <div class="text">${category.trick}</div>
                  </div>
                </a>
              `
          })
          .join('')
      )
    }
  })

  TutorialApi.getBanners({ app: `${_app}_tutorial` }).then((res) => {
    if (res.code === 0) {
      createSwiper($('.block-top'), res.data.banners)
    }
  })
}

function fixScrollConflictInApp() {
  const invokeApp = new WebviewInvokeApp()
  function postBannerInfo() {
    const e = $('.block-top').get(0)
    const box = e.getBoundingClientRect()
    const x = box.left
    const y = box.top
    var width = e.clientWidth
    var height = e.clientHeight
    //调用android代码
    invokeApp.postBannerInfo(x, y, width, height)
  }

  $(window).on('scroll load', function () {
    postBannerInfo()
  })
}

function useThingkingdata() {
  const $page = $('.page')

  $page.on('click', '.type[data-type="tutorial"]', function () {
    ta.track('click_story_tutorial')
    ta.timeEvent('story_tutorial_load_finish')
  })

  $page.on('click', '.type[data-type="play"]', function () {
    ta.track('click_story_play')
    ta.timeEvent('story_play_load_finish')
  })

  $page.on('click', '.banner', function () {
    const banner_id = $(this).attr('data-id')
    const banner_url = $(this).attr('href')
    const banner_name = $(this).attr('data-name')
    ta.track('click_story_banner', { banner_id, banner_url, banner_name })
  })
}

function Page({ _app }) {
  const { __ } = React.useContext(CommonContext)
  React.useEffect(() => {
    init({ _app })
    fixScrollConflictInApp()
    if (_app === 'oner') {
      useThingkingdata()
    }
  }, [])
  return (
    <>
      <div className='page'>
        <div className='block-top'></div>
        <div className='block-bottom'>
          <a href={`/tutorial/manuals/${_app}`} className='type' data-type='tutorial'>
            <div className='text-group'>
              <div className='text'>{__['app.tutorial.manuals.title']}</div>
            </div>
          </a>
        </div>
      </div>
      <ThinkingDataSDK />
      <VolcEngine />
    </>
  )
}

Page.injectData = function ({ locals }) {
  return {
    localeData: {
      namespaces: ['common', 'app'],
    },
  }
}

export const getServerSideProps = async ({ req, res }) => {
  const app = res.params.app || 'go'
  return {
    props: {
      _app: app,
    },
  }
}

export default Page
